'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { searchParamsData } from '@/lib/sbAPI'
import { getStoryblokApi } from '@/lib/storyblok-api'

import { PhnxImageHolder } from '../../01-atoms/ImageHolder/ImageHolder'
import { PhnxMemberdetails } from './Memberdetails'
import { MemberdetailsProps } from './Memberdetails'

interface MemberdetailsBlokProps {
  blok: {
    title: MemberdetailsProps['title']
    position: any
    description: any
    asset: any
    photo: any
  } & SbBlokData
  name: string
}

const Memberdetails: FC<MemberdetailsBlokProps> = ({ blok, name }) => {
  const [relatedPeopleFind, setRelatedPeople] = useState<any>([])
  const [memberListBlok, setMemberListBlok] = useState<any>([])

  useEffect(() => {
    // fetch related articles
    const fetchRelatedArticles = async () => {
      // if blok.relatedArticles is set, we don't need to fetch the related articles

      // TODO: this should be reusable
      let location = process.env.NEXT_PUBLIC_NEXT_LOCATION
        ? process.env.NEXT_PUBLIC_NEXT_LOCATION
        : 'au'
      let filterLocation = location === 'en-nz' ? 'au' : `en-nz`

      let sbParams = {
        ...searchParamsData,
        filter_query: {
          component: { in: 'people' },
          __or: [
            { 'settings.location_available': { in: location } },
            { 'settings.location_available': { not_in: filterLocation } },
          ],
        },
        sort_by: 'created_at:asc',
        per_page: 100,
      }

      const storyblokApi = getStoryblokApi()
      let { data } = await storyblokApi.get(`cdn/stories/`, sbParams)
      setRelatedPeople(data?.stories || [])
    }
    fetchRelatedArticles()
  }, [blok._uid, blok.relatedArticles])

  type MemberList = { label: string; values: string[]; links: string[] }[]

  const transformData = (dataItems: any[]): MemberList => {
    const grouped = dataItems.reduce(
      (acc: Record<string, { values: string[]; links: string[] }>, item: any) => {
        const rawLabel = item.full_slug.split('/')[1]
        const formattedLabel = rawLabel
          .split('-')
          .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')

        if (!acc[formattedLabel]) {
          acc[formattedLabel] = { values: [], links: [] }
        }

        acc[formattedLabel].values.push(item.name)
        acc[formattedLabel].links.push('/' + item.full_slug)
        return acc
      },
      {}
    )

    return Object.entries(grouped).map(([label, { values, links }]) => ({ label, values, links }))
  }

  useEffect(() => {
    const arrayData = transformData(relatedPeopleFind)
    setMemberListBlok(arrayData)
  }, [relatedPeopleFind])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxMemberdetails
        title={name}
        position={blok.role ? blok.role : ''}
        description={
          blok.bio && Array.isArray(blok.bio)
            ? blok.bio.map((child: SbBlokData) => (
                <StoryblokServerComponent blok={child} key={child._uid} />
              ))
            : null
        }
        asset={
          blok.photo && (
            <PhnxImageHolder images={[{ src: blok.photo.filename, alt: blok.photo.alt }]} />
          )
        }
        memberList={memberListBlok}
      />
    </div>
  )
}

export default Memberdetails
